import { Button as MUIButton } from '@mui/material';

/**
 * Project alias for MUI's Button. Import from here instead of `@mui/material`
 * so the whole app tracks one button implementation. All MUI Button props
 * pass through.
 */
const Button = props => <MUIButton {...props} />;

export default Button;
